import { ComponentFactoryResolver, Inject, Injectable, NgZone } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DashboardResponsiveApiModelSparse, SaveDashboardModalData } from 'src/shared/models/dashboard.model';
import { DashboardServiceBase } from 'src/shared/services/dashboard-service-base';
import { WINDOW_INJECTION_TOKEN } from '../injection-tokens';
import { CVApiService } from '../reusables/services/cv-api.service';
import { CvConfigurationService } from '../reusables/services/cv-configuration.service';
import { SharedServiceHelperService } from '../reusables/services/shared-service-helper.service';
import { AngularModuleService } from './angular-module.service';
import { SaveDashboardModalComponent } from './modals/save-dashboard-modal/save-dashboard-modal.component';

import { CvDialogService } from '../reusables/confirm-dialog/cv-dialog.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardService extends DashboardServiceBase {

    constructor(
        sshs: SharedServiceHelperService,
        cvApiService: CVApiService,
        angularModuleService: AngularModuleService,
        config: CvConfigurationService,
        @Inject(WINDOW_INJECTION_TOKEN) window: Window,
        componentFactoryResolver: ComponentFactoryResolver,
        modalService: NgbModal,
        ngZone: NgZone,
        cvDialogService: CvDialogService,
    ) {
        super(
            sshs.getSharedServicesEnabled(),
            cvApiService,
            angularModuleService,
            config,
            window
        );
        // add Angular specific code to the dashboard service base
        const base = DashboardServiceBase.getServiceBase();
        super.setAngularComponentFactoryResolver(componentFactoryResolver);
        base.openSaveDashboardModal =
        (data: SaveDashboardModalData, type: string, showFolder: boolean = true): Observable<DashboardResponsiveApiModelSparse> => {
            let modalRef: NgbModalRef;
            ngZone.run(() => {
                modalRef = modalService.open(SaveDashboardModalComponent, { centered: true, modalDialogClass: 'saveDashboardModal' });
                const component: SaveDashboardModalComponent = modalRef.componentInstance;
                component.type = type;
                component.data = data;
                component.showFolder = showFolder;
            });
            return modalRef.closed;
        };

        base.openConfirmLeaveModal = (dashboard: DashboardResponsiveApiModelSparse, isFromPrebuiltReport = false): Observable<DashboardResponsiveApiModelSparse> => {
            let modalRef: NgbModalRef;
            ngZone.run(async () => {
                modalRef = cvDialogService.showConfirmDialog(
                    "Leave?", // localized in confirm dialog component
                    "All changes will be lost.",
                    true,
                    () => this.leaveDashPage(dashboard, isFromPrebuiltReport),
                    () => this.selectedDashboard = this.lastSelectedDashboard
                );
            });
            return modalRef.closed;
        };
    }
}
